<div class="form-group" [ngClass]="marginClass">
    @if (label) {
        <label [ngClass]="labelClass" [attr.for]="for">
            {{ label }}
            @if (required) {
                <sup>*</sup>
            }
        </label>
    }

    <ng-content></ng-content>
</div>
